import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../../shared/Fetch";

const MonsterTeamSettingTable = (props: any) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dt = useRef<any>(null);
  const loadTableData = async () => {
    setLoading(true);
    const response = await Fetch("Monster_Setting/getMonsterTeamSetting", "GET", null, null, props.toast);

    if (response) {
      const data = await response.json();
      setTableData(data);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadTableData();
  }, [props.reload]);

  return (
    <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" ref={dt} value={tableData} emptyMessage="No Data found." loading={loading} showGridlines stripedRows responsiveLayout="scroll">
      {/* <Column field="team_Name" header="Team Name" /> */}
      <Column
        header="Team Details"
        body={(rowData) => (
          <div>
            <div>
              <b>{rowData.team_Name}</b>
            </div>
            <div style={{ fontSize: "12px", color: "gray" }}>{rowData.branch_Name}</div>
          </div>
        )}
      />
      <Column field="no_Of_Views" header="No of View Allowed" />
    </DataTable>
  );
};

export default MonsterTeamSettingTable;
